export class PublicationSessionStorageCommon {
    static readonly STORAGE_KEY_PREFIX = 'pbs_publications_';

    static get(key: string): any {
        const sessionKey = this.createKey(key);
        const data = sessionStorage.getItem(sessionKey);
        return data ? JSON.parse(data) : null;
    }

    static set(key: string, data: any): void {
        const sessionKey = this.createKey(key);
        sessionStorage.setItem(sessionKey, JSON.stringify(data));
    }

    static clear(key: string): void {
        const sessionKey = this.createKey(key);
        sessionStorage.removeItem(sessionKey);
    }

    private static createKey(suffix: string): string {
        return `${PublicationSessionStorageCommon.STORAGE_KEY_PREFIX}${suffix}`;
    }
}
